import { ArticleDataObject } from "@app/types/Cue";
import LoadMore from "@components/LoadMore/LoadMore";
import { useLoadMoreArticlesByProfileId } from "@hooks/useLoadMoreArticlesByProfileId";

import AuthorListingArticles from "./AuthorListingArticles";

export type AuthorArticlesProps = {
  articles: ArticleDataObject[];
  profileId: string;
};

export default function AuthorArticles({
  articles,
  profileId,
}: AuthorArticlesProps): React.ReactElement {
  const { articleList, handleLoadMore, hasMoreArticles } =
    useLoadMoreArticlesByProfileId(profileId, articles);

  return (
    <div data-testid="author-articles-component">
      <div className="stories">
        {articleList.map((article, index) => {
          return (
            <AuthorListingArticles key={article.id} {...{ article, index }} />
          );
        })}
      </div>

      {hasMoreArticles ? (
        <LoadMore
          rootClassName="my-4"
          loadText="Load More"
          onLoadMore={handleLoadMore}
        />
      ) : null}
    </div>
  );
}
